<template>
  <ButtonSquareHoverChecklist
    :title="$t('general__view__drawing')"
    :imgSource="iconDrawings"
    size="large"
    :hoverButtons="hoverButtons"
    :activeState="activeState"
    @clicked="toggleButton"
    @hovered="onHover"
    @onChecklistToggle="updateFilteredDrawings"
  />
</template>

<script lang="ts" setup>
import ButtonSquareHoverChecklist from '@/components/general/buttons/ButtonSquareHoverChecklist.vue'
import { useGeneralStore } from '@/pinia'
import { computed, ref } from 'vue'
import iconDrawings from '@/assets/icon-drawings.svg'

const emits = defineEmits<{
  (e: 'MapDrawingButtonHovered'): void
}>()
const piniaStore = useGeneralStore()

const buttonActive = ref(false)
const activeState = computed(() => {
  if (hoverButtons.value && hoverButtons.value.length)
    return buttonActive.value ? 'active' : 'inactive'
  return 'deactivated'
})

const hoverButtons = computed(() => {
  const layers: any[] = []
  piniaStore.filteredDrawings.forEach((drawing) => {
    layers.push({
      ...drawing,
      types: [{}],
      disabled: false
    })
  })
  return layers
})

function onHover() {
  if (activeState.value !== 'deactivated') {
    emits('MapDrawingButtonHovered')
  }
}
function toggleButton() {
  if (activeState.value === 'deactivated') return
  buttonActive.value = !buttonActive.value
}

function updateFilteredDrawings(id) {
  const drawingLayers = piniaStore.filteredDrawings
  const index = drawingLayers.findIndex((layer) => layer.id === id)
  if (index === -1) return
  drawingLayers[index].visible = !drawingLayers[index].visible
  piniaStore.setFilteredDrawings(drawingLayers)
}
</script>
